var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _circle7, _circle8, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3304,
    cy: 79.6874,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2679,
    cy: 47.9464,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.813,
    cy: 28.7945,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2054,
    cy: 109.955,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.688,
    cy: 104.866,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.509,
    cy: 110.759,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.141 88.7493L127.961 92.6245L131.781 93.4566L127.961 94.2888L127.141 98.1639L126.321 94.2888L122.501 93.4566L126.321 92.6245L127.141 88.7493Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.235 49.1843C122.295 48.9011 122.699 48.9011 122.759 49.1843L123.282 51.6521C123.304 51.7552 123.384 51.8359 123.487 51.8583L125.936 52.3919C126.217 52.4532 126.217 52.8541 125.936 52.9153L123.487 53.4489C123.384 53.4714 123.304 53.5521 123.282 53.6552L122.759 56.1229C122.699 56.4061 122.295 56.4061 122.235 56.123L121.713 53.6552C121.691 53.5521 121.611 53.4714 121.508 53.4489L119.059 52.9153C118.777 52.8541 118.777 52.4532 119.059 52.3919L121.508 51.8583C121.611 51.8359 121.691 51.7552 121.713 51.6521L122.235 49.1843Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9705 81.5951C25.0304 81.3119 25.4346 81.3119 25.4946 81.5951L26.39 85.8252C26.4118 85.9283 26.492 86.009 26.595 86.0315L30.7815 86.9435C31.0626 87.0047 31.0626 87.4057 30.7815 87.4669L26.595 88.379C26.492 88.4014 26.4118 88.4821 26.39 88.5852L25.4946 92.8154C25.4346 93.0985 25.0304 93.0985 24.9705 92.8154L24.0751 88.5852C24.0532 88.4821 23.973 88.4014 23.87 88.379L19.6836 87.4669C19.4024 87.4057 19.4024 87.0047 19.6836 86.9435L23.87 86.0315C23.973 86.009 24.0532 85.9283 24.0751 85.8252L24.9705 81.5951Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 36.5723C41.5033 36.5393 41.5033 36.3176 41.6586 36.2846L44.0065 35.7853C44.0631 35.7733 44.1074 35.7292 44.1197 35.6726L44.6252 33.3412C44.6587 33.1867 44.8792 33.1867 44.9127 33.3412L45.4182 35.6726C45.4305 35.7292 45.4747 35.7733 45.5313 35.7853L47.8793 36.2846C48.0346 36.3176 48.0346 36.5393 47.8793 36.5723L45.5313 37.0716C45.4747 37.0836 45.4305 37.1277 45.4182 37.1843L44.9127 39.5157C44.8792 39.6702 44.6587 39.6702 44.6252 39.5157L44.1197 37.1843C44.1074 37.1277 44.0631 37.0836 44.0065 37.0716L41.6586 36.5723Z",
    fill: "#F8AFAF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1071,
    cy: 62.4107,
    r: 29.7321,
    fill: "#FFD3D2",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1072,
    cy: 62.4105,
    r: 24.9107,
    fill: "#FFE7E7",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3331 117.489L61.4025 95.1703L62.1167 94.6347L63.7237 94.2776H66.0448L67.2946 95.1703L68.5445 95.706L69.6158 96.9558L70.5085 98.9199L56.5817 125.167L54.9748 126.059H53.0107L50.3325 125.167L48.1899 124.274L46.2259 121.596L45.3331 120.524V117.489Z",
    fill: "#FFD3D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5439 90.3497L69.4701 96.956",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7559 88.207L64.8278 94.0991",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4738 94.2776L45.1545 118.025",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.33 98.5629L56.4032 125.524",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1168 94.6348L62.4107 94.4712C63.0537 94.1132 63.7925 93.9652 64.5238 94.0482V94.0482C64.8224 94.0821 65.1155 94.154 65.3958 94.2621L65.8991 94.4563L66.0687 94.5129C67.0139 94.8279 67.8728 95.3587 68.5773 96.0632V96.0632L69.1311 96.617C69.3562 96.8421 69.5529 97.094 69.7167 97.367V97.367C69.9084 97.6865 70.0532 98.0318 70.1468 98.3924L70.33 99.0986",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7602 125.167L55.9997 125.509C55.263 125.84 54.4685 126.024 53.6611 126.049V126.049C53.0341 126.069 52.4077 125.993 51.8036 125.824L51.2914 125.68L51.1196 125.622C49.6017 125.107 48.2193 124.256 47.0752 123.134V123.134L46.4138 122.485C45.8967 121.977 45.5091 121.353 45.2838 120.664V120.664C45.0034 119.808 44.9856 118.887 45.2326 118.02L45.333 117.668",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProduct);
export default __webpack_public_path__ + "static/media/empty_product.c887c15c047ae4e2c4a4e5715166358f.svg";
export { ForwardRef as ReactComponent };